import React from "react";
import "../styles/Guarantee.css";
import { useLanguage } from "../contexts/LanguageContext";

const ICONS = {
  shield: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
      <path d="M12 2l8 4v6c0 5-3.5 9-8 10-4.5-1-8-5-8-10V6l8-4z" strokeLinejoin="round" />
      <path d="M9 12l2 2 4-4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  lock: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
      <rect x="4" y="11" width="16" height="10" rx="2" />
      <path d="M8 11V7a4 4 0 0 1 8 0v4" />
    </svg>
  ),
  code: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
      <path d="M16 18l6-6-6-6M8 6l-6 6 6 6M14 4l-4 16" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  support: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
      <path d="M21 15a4 4 0 0 1-4 4h-3l-4 3v-3H7a4 4 0 0 1-4-4V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4v8z" strokeLinejoin="round" />
    </svg>
  ),
};

const Guarantee = () => {
  const { language, text } = useLanguage();
  const isHeb = language === "he";
  const g = text.guarantee;

  return (
    <section id="guarantee" className="guarantee-section" dir={isHeb ? "rtl" : "ltr"}>
      <span className="eyebrow">{g.eyebrow}</span>
      <h2 className="section-title">{g.title}</h2>
      <p className="guarantee-lede">{g.lede}</p>

      <div className="guarantee-grid">
        {g.items.map((item) => (
          <div key={item.title} className="guarantee-card">
            <div className="guarantee-icon" aria-hidden="true">
              {ICONS[item.icon]}
            </div>
            <h3 className="guarantee-title">{item.title}</h3>
            <p className="guarantee-desc">{item.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Guarantee;
